import React, { useEffect, useState } from "react";
import { Button, Tooltip } from "antd";
import { AimOutlined, DashboardOutlined, WarningOutlined } from "@ant-design/icons";
import SaltFogCamera from "../../api/SaltFogCamera";
import StationPickerModal from "../modal/weather/StationPickerModal";
import WeatherChart from "../chart/WeatherChart";

/**
 * Function16：鹽霧害影像機具的氣象列（mobileType 13 的第二列）
 * 第一列是 Function3（串流），座標也在 Function3 的設定視窗編輯。
 */
export default function Function16({ machineID, data, status }) {
  const [info, setInfo] = useState(null);
  const [stationModal, setStationModal] = useState(false);
  const [chartModal, setChartModal] = useState(false);

  const current = info || data || {};

  const refresh = () => {
    if (!machineID) return;
    SaltFogCamera.GetData(machineID)
      .then((res) => res.code === 200 && setInfo(res.data))
      .catch(() => {});
  };

  useEffect(refresh, [machineID, status]);

  const fmt = (v, digits = 1) => (v != null ? Number(v).toFixed(digits) : "--");
  const fmtTime = (t) => {
    const d = new Date(t);
    return `${d.getMonth() + 1}/${d.getDate()} ${String(d.getHours()).padStart(2, "0")}:00`;
  };

  return (
    <td className="ant-table-cell" style={{ textAlign: "center" }}>
      <div style={{ display: "flex", flexDirection: "column", gap: 6, alignItems: "center" }}>
        <div style={{ fontSize: 12, color: "var(--primary-text)", fontWeight: 500 }}>鹽霧害氣象監測</div>

        {current.coord_is_default && (
          <Tooltip title="經緯度仍是預設值，請在上方影像列的「設定」填寫機具實際座標後再選站">
            <div style={{ fontSize: 12, color: "#faad14" }}>
              <WarningOutlined /> 尚未設定機具座標
            </div>
          </Tooltip>
        )}

        {current.station_name ? (
          <div style={{ fontSize: 12, color: "var(--primary-text)" }}>
            氣象站：{current.station_name}
            {current.station_distance != null && ` (${Number(current.station_distance).toFixed(2)}km)`}
          </div>
        ) : (
          <div style={{ fontSize: 12, color: "var(--secondary-text)" }}>尚未選擇氣象站</div>
        )}

        {(current.weather_temperature != null || current.weather_humidity != null) && (
          <div style={{ fontSize: 12, color: "var(--secondary-text)" }}>
            🌡 {fmt(current.weather_temperature)}°C　💧 {fmt(current.weather_humidity, 0)}%
          </div>
        )}

        {current.recent_temp_max != null && (
          <div style={{ fontSize: 12, color: "var(--secondary-text)" }}>
            最高 <span style={{ color: "#ff4d4f" }}>{fmt(current.recent_temp_max)}</span> / 最低{" "}
            <span style={{ color: "#4096ff" }}>{fmt(current.recent_temp_min)}</span>°C
            ，溫差 <b style={{ color: "#fa8c16" }}>{fmt(current.recent_temp_diff)}°C</b>
          </div>
        )}

        {current.weather_time && (
          <div style={{ fontSize: 11, color: current.weather_is_stale ? "#d46b08" : "#aaa" }}>
            {current.weather_is_stale && <WarningOutlined style={{ marginRight: 4 }} />}
            資料時間 {fmtTime(current.weather_time)}
            {current.weather_is_stale && "（目前無新觀測）"}
          </div>
        )}

        <div style={{ display: "flex", gap: 6, marginTop: 4 }}>
          <Button icon={<AimOutlined />} size="small" onClick={() => setStationModal(true)}>
            選站
          </Button>
          <Button
            icon={<DashboardOutlined />}
            size="small"
            onClick={() => setChartModal(true)}
            disabled={!current.selected_station_id}
            title={current.selected_station_id ? "溫濕度圖表" : "請先選擇氣象站"}
          >
            圖表
          </Button>
        </div>
      </div>

      <StationPickerModal
        open={stationModal}
        onClose={() => setStationModal(false)}
        loadStations={() => SaltFogCamera.GetNearbyStations(machineID, 30)}
        selectStation={(stationId) => SaltFogCamera.SelectStation(machineID, stationId)}
        onSelected={refresh}
        deviceLabel="📷 鹽霧害影像機具"
        coordHint="機具座標仍是預設值，附近站點不正確。請先在影像列的「設定」填寫經緯度。"
      />

      <WeatherChart
        open={chartModal}
        onClose={() => setChartModal(false)}
        fetchChart={(opts) => SaltFogCamera.GetChartData(machineID, opts)}
        title="鹽霧害溫濕度圖表"
      />
    </td>
  );
}